import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import { podcastTypes } from '../../lib/utils';
import memoizeOne from 'memoize-one';
import AppSideScroll from './AppSideScroll';
import { colors, spacing } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppCustomLink from './AppCustomLink';
import { Modal, Tooltip } from 'antd';
import Interests from './Interests';
import { podcastTypesExtra, superGenres } from '../../lib/genres';
import { InfoCircleOutlined } from '@ant-design/icons';

class TrendingInterests extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false
        }
    }

    getUserInterests = memoizeOne((userInterests) => {
        console.dir(userInterests);
        let genreMapsList = [];
        superGenres().forEach((genreMap) => {
            if (genreMap['id'] in userInterests) {
                const genreId = genreMap['id'];
                genreMapsList.push(genreMap);
                // if ('subGenres' in podcastTypesExtra()[genreId]) {
                //     podcastTypesExtra()[genreId]['subGenres'].forEach((element) => {
                //         genreMapsList.push({ ...element, 'parentGenreId': genreId });
                //     });
                // }
            }
        });
        console.dir(genreMapsList);
        return genreMapsList;
    });

    openModal = () => {
        this.setState({ visible: true });
    }
    handleClose = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    render() {
        const { userInterests } = this.props;
        const { visible } = this.state;
        console.dir(userInterests);
        if (!userInterests) {
            return <div></div>
        }
        let genreMapsList = this.getUserInterests(userInterests);
        console.dir(genreMapsList);
        let genreMapsListFin = [...genreMapsList, {}];

        return (
            <div>
                {visible && <Modal
                    title=""
                    visible={visible}
                    // onOk={this.handleOk}
                    // onCancel={this.handleCancel}
                    closable={false}
                    footer={null}
                >
                    <Interests isEdit={true} handleClose={this.handleClose} />
                </Modal>}
                <AppSideScroll title={'Trending in your Goals'}>
                    {
                        genreMapsListFin.map((genreMap, index) =>
                            <div key={index}>
                                {index < genreMapsList.length &&
                                    <AppCustomLink as={`/trending-books/${genreMap.id}`} href={`/trending-books?id=${genreMap.id}`} >
                                        <a>
                                            <div
                                                style={{
                                                    marginRight: `${spacing('lg')}`,
                                                    background: 'hsla(223.9, 63.7%, 62.2%,1)', padding: '1em 1.5em', borderRadius: '8px', width: '220px', height: '88px'
                                                }}>
                                                <div style={{ height: '32px' }}>
                                                    {genreMap['icon'] ?
                                                        <div>
                                                            <FontAwesomeIcon style={{ color: 'white', fontSize: '1.25em', marginBottom: '4px' }}
                                                                icon={['fas', genreMap['icon']]}
                                                            />
                                                        </div> :
                                                        <div style={{ textAlign: 'right' }}>
                                                            <Tooltip placement="top" title={`This is a sub-genre under ${genreMap['parentGenreId']}`}>
                                                                <InfoCircleOutlined style={{ color: 'white', fontSize: '1.25em' }} />
                                                            </Tooltip></div>}
                                                </div>
                                                <p style={{ color: 'white', marginBottom: '0' }}>{genreMap['name']}</p>
                                            </div>
                                        </a>
                                    </AppCustomLink>
                                }
                                {index === (genreMapsListFin.length - 1) &&
                                    <div onClick={this.openModal} style={{
                                        marginRight: `${spacing('lg')}`, cursor: 'pointer',
                                        background: 'hsla(223.9, 63.7%, 62.2%,1)', padding: '1em 1.5em', borderRadius: '8px', width: '220px', height: '88px'
                                    }}>
                                        <FontAwesomeIcon style={{ color: 'white', fontSize: '1.25em', marginBottom: '8px' }} icon='pen' />
                                        <p style={{ color: 'white', marginBottom: '0' }}>Edit Your Goals</p>
                                    </div>
                                }
                            </div>
                        )
                    }
                </AppSideScroll>
            </div>
        )
    }
}

TrendingInterests.propTypes = {
    userInterests: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        userInterests: state.userInterests
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // fetchLatestSubscribedEpisodes: bindActionCreators(fetchLatestSubscribedEpisodes, dispatch),
    }
};

// export default withRedux(initStore, null, null)(Home);
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Home);

export default connect(mapStateToProps, mapDispatchToProps)(TrendingInterests);